module.exports = __webpack_public_path__ + "img/logo_ajx.fde8f292.png";